export const GET_RESTAURANT_SETTINGS_API = "/settings/";
export const UPDATE_RESTAURANT_SETTINGS_API = "/settings/";

export const GET_EMAIL_SETTINGS_API = "/settings/email/";
export const UPDATE_EMAIL_SETTINGS_API = "/settings/email/";

export const GET_OPENING_HOURS_API = "/settings/opening-hours/";
export const ADD_OPENING_HOUR_API = "/settings/opening-hours/";
export const UPDATE_OPENING_HOUR_API = "/settings/opening-hours/";
export const DELETE_OPENING_HOUR_API = "/settings/opening-hours/";

export const GET_CUSTOM_EVENTS_API = "/settings/custom-events/";
export const ADD_CUSTOM_EVENT_API = "/settings/custom-events/";
export const UPDATE_CUSTOM_EVENT_API = "/settings/custom-events/";
export const DELETE_CUSTOM_EVENT_API = "/settings/custom-events/";

export const MESSAGE_SAMPLES_API = "/settings/message-samples/";
export const MESSAGE_SAMPLE_TYPES_API = "/settings/message-samples/types/";

export const RESERVATION_CONDITIONS_API = "/settings/reservation-conditions/";

export const SPECIAL_OPTION_CATEGORIES_API = "/settings/special-option-categories/";
export const SPECIAL_OPTIONS_API = "/settings/special-options/"



// WEBPACK FOOTER //
// ./src/apis/settings.js